/**
 * Lucky wheel — Zalify modal-content + Shopify customer form (no full-page redirect).
 */
(function () {
  var SPIN_MS = 4200;
  var sectionRuntime = {};

  function parseConfig(root) {
    var script = root.querySelector('[data-lucky-wheel-config]');
    if (!script) {
      return null;
    }
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function parseCodes(raw) {
    if (!raw || typeof raw !== 'string') {
      return [];
    }
    return raw
      .split(/\r?\n/)
      .map(function (line) {
        return line.trim();
      })
      .filter(Boolean);
  }

  function pickPrizeIndex(prizes) {
    var total = 0;
    var i;
    for (i = 0; i < prizes.length; i++) {
      total += Math.max(1, parseInt(prizes[i].weight, 10) || 1);
    }
    var random = Math.random() * total;
    for (i = 0; i < prizes.length; i++) {
      random -= Math.max(1, parseInt(prizes[i].weight, 10) || 1);
      if (random <= 0) {
        return i;
      }
    }
    return prizes.length - 1;
  }

  function hashForStorage(value) {
    var str = String(value || '').toLowerCase().trim();
    var hash = 0;
    var i;
    for (i = 0; i < str.length; i++) {
      hash = (Math.imul(31, hash) + str.charCodeAt(i)) | 0;
    }
    return 'h' + (hash >>> 0).toString(36);
  }

  function getSpinCountKey(campaignId, email) {
    return 'lw-spins-' + campaignId + '-' + hashForStorage(email);
  }

  function getSeenKey(campaignId) {
    return 'lw-seen-' + campaignId;
  }

  function getUsedCodesKey(campaignId, prizeId) {
    return 'lw-codes-used-' + campaignId + '-' + prizeId;
  }

  function getAssignedCodeKey(campaignId, prizeId, email) {
    return 'lw-code-assigned-' + campaignId + '-' + prizeId + '-' + hashForStorage(email);
  }

  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function writeCookie(name, value, days) {
    var maxAge = days * 24 * 60 * 60;
    document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
  }

  function getSpinCount(campaignId, email) {
    var key = getSpinCountKey(campaignId, email);
    var fromStorage = parseInt(localStorage.getItem(key) || '0', 10);
    var fromCookie = parseInt(readCookie(key) || '0', 10);
    return Math.max(fromStorage, fromCookie, 0);
  }

  function setSpinCount(campaignId, email, count) {
    var key = getSpinCountKey(campaignId, email);
    localStorage.setItem(key, String(count));
    writeCookie(key, String(count), 365);
  }

  function getPrizePoolCodes(prize, config) {
    var raw = prize.poolCodes || '';
    var codes = parseCodes(raw);
    var maxCodes = parseInt(config.poolMaxCodes, 10) || 30;
    if (codes.length > maxCodes) {
      codes = codes.slice(0, maxCodes);
    }
    return codes;
  }

  function resolvePrizeCode(prize, campaignId, email, config) {
    var mode = prize.codeMode || 'public';

    if (prize.type !== 'discount' || mode === 'none') {
      return { code: '', exhausted: false, isPublic: false };
    }

    if (mode === 'public') {
      var publicCode = (prize.publicCode || '').trim();
      return { code: publicCode, exhausted: false, isPublic: true };
    }

    if (mode === 'unique_pool') {
      var assignedKey = getAssignedCodeKey(campaignId, prize.id, email);
      var existing = localStorage.getItem(assignedKey);
      if (existing) {
        return { code: existing, exhausted: false, isPublic: false };
      }

      var codes = getPrizePoolCodes(prize, config);
      if (!codes.length) {
        return { code: '', exhausted: false, isPublic: false };
      }

      var used = [];
      try {
        used = JSON.parse(localStorage.getItem(getUsedCodesKey(campaignId, prize.id)) || '[]');
      } catch (e) {
        used = [];
      }

      var available = codes.filter(function (code) {
        return used.indexOf(code) === -1;
      });

      if (!available.length) {
        return { code: '', exhausted: true, isPublic: false };
      }

      var picked = available[Math.floor(Math.random() * available.length)];
      used.push(picked);
      localStorage.setItem(getUsedCodesKey(campaignId, prize.id), JSON.stringify(used));
      localStorage.setItem(assignedKey, picked);
      return { code: picked, exhausted: false, isPublic: false };
    }

    return { code: '', exhausted: false, isPublic: false };
  }

  function setupCanvas(canvas, prizes, size) {
    var wrap = canvas.closest('.lucky-wheel__wheel-wrap') || canvas.parentElement;
    var measured = wrap ? Math.round(wrap.getBoundingClientRect().width) : 0;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var px = size || measured || 320;
    canvas.width = px * dpr;
    canvas.height = px * dpr;
    canvas.style.width = '100%';
    canvas.style.height = '100%';

    var ctx = canvas.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    drawWheel(ctx, px, prizes);
  }

  function fitWheelCanvases(modal, config) {
    var canvas = modal.querySelector('[data-lucky-wheel-canvas]');
    var previewCanvas = modal.querySelector('[data-lucky-wheel-preview]');
    if (canvas) {
      var spinWrap = canvas.closest('.lucky-wheel__wheel-wrap');
      var spinSize = spinWrap ? Math.round(spinWrap.getBoundingClientRect().width) : 320;
      setupCanvas(canvas, config.prizes, spinSize || 320);
    }
    if (previewCanvas) {
      var previewWrap = previewCanvas.closest('.lucky-wheel__wheel-wrap');
      var previewSize = previewWrap ? Math.round(previewWrap.getBoundingClientRect().width) : 240;
      setupCanvas(previewCanvas, config.prizes, previewSize || 240);
    }
  }

  function drawWheel(ctx, size, prizes) {
    var radius = size / 2;
    var count = prizes.length;
    var slice = (Math.PI * 2) / count;
    var start = -Math.PI / 2;
    var i;

    ctx.clearRect(0, 0, size, size);

    for (i = 0; i < count; i++) {
      var end = start + slice;
      ctx.beginPath();
      ctx.moveTo(radius, radius);
      ctx.arc(radius, radius, radius - 4, start, end);
      ctx.closePath();
      ctx.fillStyle = prizes[i].color || '#f5c518';
      ctx.fill();

      ctx.save();
      ctx.translate(radius, radius);
      ctx.rotate(start + slice / 2);
      ctx.textAlign = 'right';
      ctx.fillStyle = prizes[i].textColor || '#111';
      ctx.font = 'bold ' + (size > 260 ? 13 : 11) + 'px sans-serif';
      var label = prizes[i].label || '';
      if (label.length > 14) {
        label = label.slice(0, 13) + '\u2026';
      }
      ctx.fillText(label, radius - (size > 260 ? 18 : 14), 4);
      ctx.restore();

      start = end;
    }
  }

  function getRotationForIndex(index, count) {
    var slice = 360 / count;
    var center = index * slice + slice / 2;
    return 5 * 360 + (360 - center);
  }

  function showStep(panel, stepName) {
    panel.querySelectorAll('[data-lucky-wheel-step]').forEach(function (step) {
      var active = step.getAttribute('data-lucky-wheel-step') === stepName;
      step.classList.toggle('hidden', !active);
      step.hidden = !active;
    });
  }

  function showError(form, message) {
    var existing = form.querySelector('.lucky-wheel__error');
    if (existing) {
      existing.remove();
    }
    var el = document.createElement('p');
    el.className = 'lucky-wheel__error';
    el.setAttribute('role', 'alert');
    el.textContent = message;
    var submit = form.querySelector('[data-lucky-wheel-submit]');
    form.insertBefore(el, submit || null);
  }

  function getFieldInput(form, field) {
    if (field.type === 'birthday') {
      return form.querySelector('[data-lw-birthday-value][name="' + String(field.inputName).replace(/"/g, '\\"') + '"]');
    }
    return form.querySelector('[name="' + String(field.inputName).replace(/"/g, '\\"') + '"]');
  }

  function getBirthdayWrap(form, field) {
    var input = getFieldInput(form, field);
    return input ? input.closest('[data-lw-birthday]') : null;
  }

  function syncBirthdayHidden(wrap) {
    if (!wrap) {
      return;
    }
    var hidden = wrap.querySelector('[data-lw-birthday-value]');
    var month = wrap.querySelector('[data-lw-birthday-month]');
    var day = wrap.querySelector('[data-lw-birthday-day]');
    var year = wrap.querySelector('[data-lw-birthday-year]');
    if (!hidden || !month || !day || !year) {
      return;
    }
    if (month.value && day.value && year.value) {
      hidden.value = year.value + '-' + month.value + '-' + day.value;
    } else {
      hidden.value = '';
    }
  }

  function initBirthdayFields(form) {
    form.querySelectorAll('[data-lw-birthday]').forEach(function (wrap) {
      var daySelect = wrap.querySelector('[data-lw-birthday-day]');
      var yearSelect = wrap.querySelector('[data-lw-birthday-year]');
      var monthSelect = wrap.querySelector('[data-lw-birthday-month]');

      if (daySelect && daySelect.options.length <= 1) {
        var d;
        for (d = 1; d <= 31; d += 1) {
          var dayOpt = document.createElement('option');
          dayOpt.value = d < 10 ? '0' + d : String(d);
          dayOpt.textContent = String(d);
          daySelect.appendChild(dayOpt);
        }
      }

      if (yearSelect && yearSelect.options.length <= 1) {
        var currentYear = new Date().getFullYear();
        var y;
        for (y = currentYear; y >= 1920; y -= 1) {
          var yearOpt = document.createElement('option');
          yearOpt.value = String(y);
          yearOpt.textContent = String(y);
          yearSelect.appendChild(yearOpt);
        }
      }

      [monthSelect, daySelect, yearSelect].forEach(function (select) {
        if (!select) {
          return;
        }
        select.addEventListener('change', function () {
          syncBirthdayHidden(wrap);
        });
      });

      syncBirthdayHidden(wrap);
    });
  }

  var TEASER_CORNERS = [
    'bottom-right',
    'bottom-left',
    'top-right',
    'top-left',
    'middle-left',
    'middle-right',
  ];

  function resolveTeaserCorner(teaser, cornerOverride) {
    if (cornerOverride && TEASER_CORNERS.indexOf(cornerOverride) !== -1) {
      return cornerOverride;
    }
    if (teaser) {
      var fromData = teaser.getAttribute('data-minimized-corner');
      if (fromData && TEASER_CORNERS.indexOf(fromData) !== -1) {
        return fromData;
      }
      var i;
      for (i = 0; i < TEASER_CORNERS.length; i += 1) {
        if (teaser.classList.contains('lucky-wheel-teaser--' + TEASER_CORNERS[i])) {
          return TEASER_CORNERS[i];
        }
      }
    }
    return 'bottom-right';
  }

  function applyTeaserCorner(teaser, cornerOverride) {
    if (!teaser) {
      return;
    }
    var chosen = resolveTeaserCorner(teaser, cornerOverride);
    TEASER_CORNERS.forEach(function (name) {
      teaser.classList.remove('lucky-wheel-teaser--' + name);
    });
    teaser.classList.add('lucky-wheel-teaser--' + chosen);
    teaser.setAttribute('data-minimized-corner', chosen);

    var gap = '16px';
    teaser.style.top = '';
    teaser.style.right = '';
    teaser.style.bottom = '';
    teaser.style.left = '';
    teaser.style.transform = '';

    if (chosen === 'bottom-right') {
      teaser.style.right = gap;
      teaser.style.bottom = gap;
    } else if (chosen === 'bottom-left') {
      teaser.style.left = gap;
      teaser.style.bottom = gap;
    } else if (chosen === 'top-right') {
      teaser.style.top = gap;
      teaser.style.right = gap;
    } else if (chosen === 'top-left') {
      teaser.style.top = gap;
      teaser.style.left = gap;
    } else if (chosen === 'middle-left') {
      teaser.style.top = '50%';
      teaser.style.left = gap;
      teaser.style.transform = 'translateY(-50%)';
    } else if (chosen === 'middle-right') {
      teaser.style.top = '50%';
      teaser.style.right = gap;
      teaser.style.transform = 'translateY(-50%)';
    }
  }

  function getTeaser(sectionRoot, sectionId) {
    var inSection = sectionRoot ? sectionRoot.querySelector('[data-lucky-wheel-teaser]') : null;
    if (inSection) {
      return inSection;
    }
    if (!sectionId) {
      return null;
    }
    return document.querySelector('[data-lucky-wheel-teaser][data-lw-section-id="' + sectionId + '"]');
  }

  function removeDuplicateTeasers(sectionId, keepNode) {
    if (!sectionId) {
      return;
    }
    document
      .querySelectorAll('[data-lucky-wheel-teaser][data-lw-section-id="' + sectionId + '"]')
      .forEach(function (node) {
        if (keepNode && node === keepNode) {
          return;
        }
        node.remove();
      });
  }

  function copyToClipboard(text) {
    if (!text) {
      return Promise.reject(new Error('empty'));
    }

    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).catch(function () {
        return copyToClipboardFallback(text);
      });
    }

    return copyToClipboardFallback(text);
  }

  function copyToClipboardFallback(text) {
    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.cssText = 'position:fixed;top:0;left:0;width:2em;height:2em;padding:0;border:0;opacity:0;';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      textarea.setSelectionRange(0, text.length);

      var ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (e) {
        ok = false;
      }

      document.body.removeChild(textarea);
      if (ok) {
        resolve();
      } else {
        reject(new Error('copy failed'));
      }
    });
  }

  function collectFormData(form, fields) {
    var data = {};
    var email = '';
    var extras = [];

    fields.forEach(function (field) {
      if (field.type === 'birthday') {
        syncBirthdayHidden(getBirthdayWrap(form, field));
      }
      var input = getFieldInput(form, field);
      if (!input) {
        return;
      }
      var value = (input.value || '').trim();
      if (field.isExtra || field.type === 'birthday') {
        if (value) {
          extras.push({ key: field.formsKey, value: value });
        }
        if (field.formsKey !== 'email') {
          data[field.formsKey] = value;
        }
        return;
      }
      data[field.formsKey] = value;
      if (field.inputName === 'contact[email]') {
        email = value;
      }
    });

    return { data: data, email: email, extras: extras };
  }

  function validateForm(form, fields) {
    var valid = true;
    fields.forEach(function (field) {
      if (field.type === 'birthday') {
        syncBirthdayHidden(getBirthdayWrap(form, field));
      }
      var input = getFieldInput(form, field);
      if (!input) {
        return;
      }
      input.classList.remove('input__field--error');
      if (field.type === 'birthday') {
        var wrap = getBirthdayWrap(form, field);
        if (wrap) {
          wrap.querySelectorAll('.lucky-wheel__select').forEach(function (select) {
            select.classList.remove('input__field--error');
          });
        }
      }
      if (field.required && !input.value.trim()) {
        input.classList.add('input__field--error');
        if (field.type === 'birthday') {
          var birthdayWrap = getBirthdayWrap(form, field);
          if (birthdayWrap) {
            birthdayWrap.querySelectorAll('.lucky-wheel__select').forEach(function (select) {
              if (!select.value) {
                select.classList.add('input__field--error');
              }
            });
          }
        }
        valid = false;
      }
      if ((field.type === 'email' || field.inputName === 'contact[email]') && input.value.trim()) {
        var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!re.test(input.value.trim())) {
          input.classList.add('input__field--error');
          valid = false;
        }
      }
      if (field.type === 'birthday' && input.value.trim()) {
        var isoDate = /^\d{4}-\d{2}-\d{2}$/;
        if (!isoDate.test(input.value.trim())) {
          input.classList.add('input__field--error');
          valid = false;
        }
      }
    });
    return valid;
  }

  function applyNoteField(form, collected, config) {
    var noteInput = form.querySelector('[data-lw-note-input]');
    if (!noteInput) {
      return;
    }
    var payload = {
      source: 'lucky-wheel',
      campaign_id: config.campaignId || '',
      email: collected.email || collected.data.email || '',
      first_name: collected.data.first_name || '',
      birthday: formatBirthdayForNote(collected.data.birthday || ''),
    };
    collected.extras.forEach(function (item) {
      if (!payload[item.key]) {
        payload[item.key] = item.value;
      }
    });
    noteInput.value = JSON.stringify(payload);
  }

  function formatBirthdayForNote(value) {
    var raw = (value || '').trim();
    if (!/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
      return raw;
    }
    var parts = raw.split('-');
    return parts[1] + '/' + parts[2] + '/' + parts[0];
  }

  function submitCustomerFormViaIframe(form) {
    return new Promise(function (resolve) {
      var frameName = 'lw-submit-' + String(Date.now());
      var iframe = document.createElement('iframe');
      iframe.name = frameName;
      iframe.title = 'Lucky wheel submit';
      iframe.setAttribute('aria-hidden', 'true');
      iframe.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;border:0';

      var finished = false;
      function complete(ok) {
        if (finished) {
          return;
        }
        finished = true;
        window.clearTimeout(fallbackTimer);
        form.removeAttribute('target');
        if (iframe.parentNode) {
          iframe.parentNode.removeChild(iframe);
        }
        resolve(ok);
      }

      var loadCount = 0;
      iframe.addEventListener('load', function () {
        loadCount += 1;
        if (loadCount >= 2) {
          complete(true);
        }
      });

      document.body.appendChild(iframe);
      form.setAttribute('target', frameName);

      var action = form.getAttribute('action') || '/contact';
      if (action.indexOf('#') !== -1) {
        form.setAttribute('action', action.split('#')[0]);
      }

      var hiddenSubmit = document.createElement('button');
      hiddenSubmit.type = 'submit';
      hiddenSubmit.hidden = true;
      form.appendChild(hiddenSubmit);
      hiddenSubmit.click();
      hiddenSubmit.remove();

      var fallbackTimer = window.setTimeout(function () {
        complete(true);
      }, 2000);
    });
  }

  function submitCustomerForm(form) {
    var action = (form.getAttribute('action') || '/contact').split('#')[0];

    return fetch(action, {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      redirect: 'manual',
      headers: {
        Accept: 'text/html,application/xhtml+xml',
      },
    })
      .then(function (response) {
        var status = response.status;
        if (status === 0 || status === 200 || status === 201 || status === 302 || status === 303) {
          return true;
        }
        return submitCustomerFormViaIframe(form);
      })
      .catch(function () {
        return submitCustomerFormViaIframe(form);
      });
  }

  function mountTeaser(teaser, sectionId) {
    if (!teaser && sectionId) {
      teaser = getTeaser(null, sectionId);
    }
    if (!teaser) {
      return null;
    }

    if (sectionId) {
      teaser.setAttribute('data-lw-section-id', sectionId);
      removeDuplicateTeasers(sectionId, teaser);
    }

    if (teaser.parentNode !== document.body) {
      document.body.appendChild(teaser);
    }

    teaser.setAttribute('data-lw-mounted', 'true');
    return teaser;
  }

  function bindTeaserInteractions(modal, teaser, config) {
    if (!teaser) {
      return;
    }

    var openBtn = teaser.querySelector('[data-lucky-wheel-teaser-open]');
    if (openBtn && openBtn.getAttribute('data-lw-bound') !== 'true') {
      openBtn.setAttribute('data-lw-bound', 'true');
      openBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        openModal(modal, teaser);
      });
    }

    var dismissBtn = teaser.querySelector('[data-lucky-wheel-teaser-dismiss]');
    if (dismissBtn && dismissBtn.getAttribute('data-lw-bound') !== 'true') {
      dismissBtn.setAttribute('data-lw-bound', 'true');
      dismissBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        closeModalCompletely(modal, teaser);
      });
    }
  }

  function openModal(modal, teaser) {
    if (teaser) {
      teaser.classList.add('hidden');
    }
    modal.open = true;
  }

  function closeModalCompletely(modal, teaser) {
    modal.open = false;
    if (teaser) {
      teaser.classList.add('hidden');
    }
  }

  function minimizeModal(modal, teaser, config) {
    modal.open = false;
    if (!teaser && config && config.sectionId) {
      teaser = getTeaser(null, config.sectionId);
    }
    if (teaser) {
      applyTeaserCorner(teaser, config && config.minimizedCorner);
      teaser.classList.remove('hidden');
    }
  }

  function blockOverlayDismiss(modal) {
    modal.addEventListener(
      'click',
      function (event) {
        if (event.target.classList.contains('modal__overlay')) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
        }
      },
      true
    );

    var overlay = modal.querySelector('[data-lucky-wheel-overlay]');
    if (overlay) {
      overlay.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
        },
        true
      );
    }
  }

  function bindModalDismiss(modal, config, teaser) {
    blockOverlayDismiss(modal);

    modal.querySelectorAll('[data-lucky-wheel-dismiss]').forEach(function (btn) {
      btn.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          closeModalCompletely(modal, teaser);
        },
        true
      );
    });

    modal.querySelectorAll('[data-lucky-wheel-close]').forEach(function (btn) {
      btn.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          if (config.allowMinimize && teaser) {
            minimizeModal(modal, teaser, config);
          } else {
            closeModalCompletely(modal, teaser);
          }
        },
        true
      );
    });
  }

  function clearSectionRuntime(sectionId) {
    if (!sectionId || !sectionRuntime[sectionId]) {
      return;
    }
    var runtime = sectionRuntime[sectionId];
    runtime.timers.forEach(function (timerId) {
      window.clearTimeout(timerId);
    });
    runtime.listeners.forEach(function (listener) {
      listener.target.removeEventListener(listener.type, listener.fn, listener.options);
    });
    delete sectionRuntime[sectionId];
  }

  function destroyLuckyWheel(sectionId) {
    if (!sectionId) {
      return;
    }
    clearSectionRuntime(sectionId);
    document
      .querySelectorAll('[data-lucky-wheel-teaser][data-lw-section-id="' + sectionId + '"]')
      .forEach(function (node) {
        node.remove();
      });
    var modal = document.getElementById('lucky-wheel-' + sectionId);
    if (modal) {
      modal.open = false;
      modal.remove();
    }
    var root = document.querySelector('[data-lucky-wheel-section="' + sectionId + '"]');
    if (root) {
      root.removeAttribute('data-lw-initialized');
    }
  }

  function setupTriggers(modal, config, teaser) {
    clearSectionRuntime(config.sectionId);
    var runtime = { timers: [], listeners: [] };
    sectionRuntime[config.sectionId] = runtime;

    var opened = false;

    function tryOpen() {
      if (!document.getElementById(config.modalId)) {
        return;
      }
      if (opened || modal.open) {
        return;
      }
      if (config.showOncePerSession && sessionStorage.getItem(getSeenKey(config.campaignId))) {
        return;
      }
      opened = true;
      openModal(modal, teaser);
      if (config.showOncePerSession) {
        sessionStorage.setItem(getSeenKey(config.campaignId), '1');
      }
    }

    if (config.triggerMode === 'scroll' || config.triggerMode === 'both') {
      var threshold = Math.max(5, Math.min(100, config.scrollPercent || 30)) / 100;
      function onScroll() {
        var scrollTop = window.scrollY || document.documentElement.scrollTop;
        var docHeight = document.documentElement.scrollHeight - window.innerHeight;
        if (docHeight <= 0) {
          tryOpen();
          return;
        }
        if (scrollTop / docHeight >= threshold) {
          tryOpen();
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      runtime.listeners.push({ target: window, type: 'scroll', fn: onScroll, options: { passive: true } });
      onScroll();
    }

    if (config.triggerMode === 'delay' || config.triggerMode === 'both') {
      var delayMs = (parseInt(config.delaySeconds, 10) || 0) * 1000;
      var delayTimer = window.setTimeout(tryOpen, delayMs);
      runtime.timers.push(delayTimer);
    }
  }

  function setSubmitting(form, isSubmitting) {
    var submit = form.querySelector('[data-lucky-wheel-submit]');
    if (!submit) {
      return;
    }
    submit.disabled = isSubmitting;
    submit.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
  }

  function setModalLocked(modal, locked) {
    if (locked) {
      modal.setAttribute('data-lw-locked', 'true');
    } else {
      modal.removeAttribute('data-lw-locked');
    }
    modal.querySelectorAll('[data-lucky-wheel-dismiss], [data-lucky-wheel-minimize], [data-lucky-wheel-overlay]').forEach(function (el) {
      if (locked) {
        el.setAttribute('aria-disabled', 'true');
        el.setAttribute('tabindex', '-1');
        el.style.pointerEvents = 'none';
        el.style.opacity = '0.35';
      } else {
        el.removeAttribute('aria-disabled');
        el.removeAttribute('tabindex');
        el.style.pointerEvents = '';
        el.style.opacity = '';
      }
    });
  }

  function runSpin(panel, wheelEl, config, winIndex) {
    showStep(panel, 'spin');
    wheelEl.style.transition = 'none';
    wheelEl.style.transform = 'rotate(0deg)';
    void wheelEl.offsetWidth;

    var rotation = getRotationForIndex(winIndex, config.prizes.length);
    wheelEl.style.transition = 'transform 4s cubic-bezier(0.2, 0.8, 0.2, 1)';
    wheelEl.style.transform = 'rotate(' + rotation + 'deg)';

    return new Promise(function (resolve) {
      setTimeout(resolve, SPIN_MS);
    });
  }

  function renderResult(resultEl, prize, codeResult, config) {
    resultEl.innerHTML = '';

    var title = document.createElement('p');
    title.className = 'lucky-wheel__result-title';
    title.textContent = prize.label || 'Result';
    resultEl.appendChild(title);

    var message = document.createElement('p');
    message.className = 'lucky-wheel__result-message';
    message.textContent = prize.message || '';
    resultEl.appendChild(message);

    if (prize.type !== 'discount') {
      return;
    }

    if (codeResult.exhausted) {
      var exhausted = document.createElement('p');
      exhausted.className = 'lucky-wheel__result-message lucky-wheel__result-message--warn';
      exhausted.textContent =
        config.poolExhaustedMessage ||
        'All unique codes for this prize have been claimed. Please contact support.';
      resultEl.appendChild(exhausted);
      return;
    }

    if (!codeResult.code) {
      var warn = document.createElement('p');
      warn.className = 'lucky-wheel__result-message lucky-wheel__result-message--warn';
      warn.textContent = 'Discount code is not configured for this prize. Please contact support.';
      resultEl.appendChild(warn);
      return;
    }

    var box = document.createElement('div');
    box.className = 'lucky-wheel__code-box';
    var codeEl = document.createElement('span');
    codeEl.className = 'lucky-wheel__code';
    codeEl.textContent = codeResult.code;
    var copyBtn = document.createElement('button');
    copyBtn.type = 'button';
    copyBtn.className = 'lucky-wheel__copy';
    copyBtn.textContent = config.copyButtonText || 'Copy';
    copyBtn.addEventListener('click', function () {
      var codeText = (codeEl.textContent || codeResult.code || '').trim();
      copyToClipboard(codeText)
        .then(function () {
          copyBtn.textContent = config.copiedButtonText || 'Copied!';
        })
        .catch(function () {
          window.prompt('Copy your code:', codeText);
        });
    });
    box.appendChild(codeEl);
    box.appendChild(copyBtn);
    resultEl.appendChild(box);

    if (codeResult.isPublic) {
      var hint = document.createElement('p');
      hint.className = 'lucky-wheel__code-hint';
      hint.textContent =
        config.publicCodeHint || 'Shared code — one use per customer (set in Shopify Admin).';
      resultEl.appendChild(hint);
    }
  }

  function handleSpin(form, modal, panel, wheelEl, resultEl, config) {
    var existingError = form.querySelector('.lucky-wheel__error');
    if (existingError) {
      existingError.remove();
    }

    if (!validateForm(form, config.fields || [])) {
      showError(form, config.validationMessage || 'Please fill in all required fields.');
      return;
    }

    var collected = collectFormData(form, config.fields || []);
    if (!collected.email) {
      showError(form, config.emailRequiredMessage || 'Email is required to spin.');
      return;
    }

    var maxSpins = parseInt(config.maxSpinsPerEmail, 10);
    if (isNaN(maxSpins) || maxSpins < 0) {
      maxSpins = 0;
    }
    var spinCount = getSpinCount(config.campaignId, collected.email);
    if (maxSpins > 0 && spinCount >= maxSpins) {
      showError(form, config.limitMessage || 'You have already used your spins for this campaign.');
      return;
    }

    applyNoteField(form, collected, config);
    setSubmitting(form, true);
    setModalLocked(modal, true);

    var winIndex = pickPrizeIndex(config.prizes);
    var prize = config.prizes[winIndex];

    Promise.all([submitCustomerForm(form), runSpin(panel, wheelEl, config, winIndex)]).then(function (results) {
      var ok = results[0];
      if (!ok) {
        showStep(panel, 'form');
        showError(form, config.submitErrorMessage || 'Could not save your entry. Please try again.');
        wheelEl.style.transition = 'none';
        wheelEl.style.transform = 'rotate(0deg)';
        setSubmitting(form, false);
        setModalLocked(modal, false);
        return;
      }

      if (maxSpins > 0) {
        setSpinCount(config.campaignId, collected.email, spinCount + 1);
      }

      var codeResult = resolvePrizeCode(prize, config.campaignId, collected.email, config);
      renderResult(resultEl, prize, codeResult, config);
      showStep(panel, 'result');
      setSubmitting(form, false);
      setModalLocked(modal, false);
      modal.open = true;
    });
  }

  function initSection(sectionRoot) {
    if (sectionRoot.getAttribute('data-lw-initialized') === 'true') {
      return;
    }
    sectionRoot.setAttribute('data-lw-initialized', 'true');

    var sectionId = sectionRoot.getAttribute('data-lucky-wheel-section');
    clearSectionRuntime(sectionId);

    var config = parseConfig(sectionRoot);
    if (!config || !config.prizes || !config.prizes.length) {
      return;
    }


    var modal = document.getElementById(config.modalId);
    var form = document.getElementById(config.formId);
    if (!modal || !form) {
      return;
    }

    var panel = modal.querySelector('[data-lucky-wheel-panel]');
    var wheelEl = modal.querySelector('[data-lucky-wheel-wheel]');
    var canvas = modal.querySelector('[data-lucky-wheel-canvas]');
    var previewCanvas = modal.querySelector('[data-lucky-wheel-preview]');
    var resultEl = modal.querySelector('[data-lucky-wheel-result]');
    if (!panel || !wheelEl || !canvas || !resultEl) {
      return;
    }

    var teaser = getTeaser(sectionRoot, config.sectionId);
    teaser = mountTeaser(teaser, config.sectionId);

    fitWheelCanvases(modal, config);
    window.setTimeout(function () {
      fitWheelCanvases(modal, config);
    }, 100);
    window.addEventListener('resize', function () {
      fitWheelCanvases(modal, config);
    });

    initBirthdayFields(form);

    if (teaser) {
      applyTeaserCorner(teaser, config.minimizedCorner);
    }
    setupTriggers(modal, config, teaser);
    bindModalDismiss(modal, config, teaser);
    bindTeaserInteractions(modal, teaser, config);

    modal.querySelectorAll('[data-lucky-wheel-minimize]').forEach(function (btn) {
      if (btn.getAttribute('data-lw-bound') === 'true') {
        return;
      }
      btn.setAttribute('data-lw-bound', 'true');
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        if (config.allowMinimize) {
          minimizeModal(modal, teaser, config);
        } else {
          closeModalCompletely(modal, teaser);
        }
      });
    });

    var submitBtn = form.querySelector('[data-lucky-wheel-submit]');
    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        handleSpin(form, modal, panel, wheelEl, resultEl, config);
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopPropagation();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-lucky-wheel-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  function getLuckyWheelSectionIdFromEvent(event) {
    if (event.detail && event.detail.sectionId) {
      return event.detail.sectionId;
    }
    if (event.target && event.target.id && event.target.id.indexOf('shopify-section-') === 0) {
      return event.target.id.replace('shopify-section-', '');
    }
    return '';
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    var section =
      (target && target.querySelector && target.querySelector('[data-lucky-wheel-section]')) ||
      (target && target.matches && target.matches('[data-lucky-wheel-section]') ? target : null);

    if (section) {
      section.removeAttribute('data-lw-initialized');
      initSection(section);
      return;
    }

    if (target && target.classList && target.classList.contains('shopify-section--lucky-wheel')) {
      destroyLuckyWheel(getLuckyWheelSectionIdFromEvent(event));
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var target = event.target;
    var section =
      (target && target.querySelector && target.querySelector('[data-lucky-wheel-section]')) ||
      (target && target.matches && target.matches('[data-lucky-wheel-section]') ? target : null);
    var sectionId = section
      ? section.getAttribute('data-lucky-wheel-section')
      : getLuckyWheelSectionIdFromEvent(event);

    if (sectionId && (section || (target && target.classList.contains('shopify-section--lucky-wheel')))) {
      destroyLuckyWheel(sectionId);
    }
  });
})();
